module.exports = __webpack_public_path__ + "static/media/StartScreem.10f0f3f3.svg";